import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import NavBar from '../navigation/navbar.js';
import Home from '../pages/home/home.js';
import Sandboxes from '../pages/sandboxes/sandboxes.js';
import Create from '../pages/create/create.js';
import Update from '../pages/update/update.js';

import './app.css';

class App extends Component {
  render() {
    return (
        <Router> 
            <NavBar />
            <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/sandboxes" component={Sandboxes} />        
                <Route exact path="/create" component={Create} />
                <Route exact path="/update/" component={Update} />
                <Route exact path="/update/:sandboxId" component={Update} />
                <Redirect to="/" />
            </Switch>
        </Router>
    );
  }
}

export default App;
